module.exports = __webpack_public_path__ + "img/ch14.c74cdef8.jpg";